<script lang="ts" setup>
import * as GameApi from '@/api/game'
import { useUserStore } from '@/stores/modules/user'

// 使用全局socket实例
const socket = window.$socket
const userStore = useUserStore()
const currentList = ref<any>([])
const personList = ref<any>([])

// 获取路由参数
const route = useRoute()
const gameurl = route.query.rid as (string | undefined)

// 监听socket事件
socket.on('betting_notice', (info) => {
  if (info.code == 0) {
    if (info.data.brVOList.length > 0)
      currentList.value = [
        ...(info.data.brVOList)
          .filter((room: any) => room.roomId == route.query.rid),
        ...currentList.value,
      ];
    personList.value = [...((info.data.brVOList).filter((room: any) => (room.roomId == route.query.rid && room.playerId == userStore.userInfo.userId))), ...personList.value];
  }
})

socket.on('room_draw_notice', (info) => {
  if (info.code == 0) {
    if (info.data.brVOList.length > 0)
      currentList.value = ((info.data.brVOList).filter((room: any) => room.roomId == route.query.rid));
    personList.value = [...((info.data.brVOList).filter((room: any) => (room.roomId == route.query.rid && room.playerId == userStore.userInfo.userId))), ...personList.value];
  }
})

socket.on('room_status_change', (info) => {
  if (info.code == 0) {
    if (info.data.runningStatus == 5)
      currentList.value = [];
  }
})

socket.on('user_amount_change_notice', (info) => {
  if (info && info.code === 0 && info.data) {
    // 更新用户钱包信息
    userStore.updateUserWallet(info.data)
  }
})

// 监听连接状态
socket.on('connect', () => {
  console.log('✅ Socket已连接')
  console.log('连接状态:', socket.isConnected())
  console.log('认证状态:', socket.isAuthenticated())
})

socket.on('disconnect', (reason) => {
  console.log('❌ Socket断开连接:', reason)
})

socket.on('error', (error) => {
  console.log('❌ Socket错误:', error)
})

socket.on('reconnect', (attemptNumber) => {
  console.log('🔄 Socket重连成功，尝试次数:', attemptNumber)
})

defineOptions({ name: 'Webview' })

// 组件卸载时清理事件监听
onBeforeUnmount(() => {
  socket.off('betting_notice')
  socket.off('room_draw_notice')
  socket.off('room_status_change')
  socket.off('user_amount_change_notice')
  socket.off('connect')
  socket.off('disconnect')
  socket.off('error')
  socket.off('reconnect')
})
</script>

<template>
  <div style="position: relative;align-items: center;">
    <el-row class="lanp" style="margin: 0 auto;" justify="center">
      <el-col :xs="24" :sm="24" :md="23" :lg="23" :xl="23">
        <IFrame :src="gameurl" style="height: 100%;" />
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
@media screen and (orientation: landscape) {
  .lanp {
    width: 89%;
  }
}
</style>
